const CloseCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="22" viewBox="0 0 24 24" width="22">
    <path d="M12 23A11 11 0 1 0 1 12a11.013 11.013 0 0 0 11 11zm0-20a9 9 0 1 1-9 9 9.01 9.01 0 0 1 9-9z" />
    <path d="M8.293 15.707a1 1 0 0 0 1.414 0L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 0 0 0 1.414z" />
  </svg>
);

export default CloseCircleIcon;
